module.exports = __webpack_public_path__ + "img/d16eaa3d2bbceaca0c0b704691d625e8.png";